import React from 'react'
import PropTypes from 'prop-types'
import { urlHelpers } from '../../helpers'

/**
* Header component for building standardized section headers with titles and
* optional links.
*/
class Header extends React.Component {
  constructor(props) {
    super(props)

    this.renderHeading = this.renderHeading.bind(this)
    this.renderLink = this.renderLink.bind(this)
  }

  /**
  * Renders the header title.
  */
  renderHeading() {
    let topTenLabel = false

    if (this.props.headerType === 'top-ten' && this.props.metaData.count !== undefined) {
      topTenLabel = <span>Top <span className="top-count can-override-text">{ this.props.metaData.count }</span></span>
    }

    return (
      <h2>
        { topTenLabel }
        { this.props.headerTitle }
      </h2>
    )
  }

  /**
  * Renders the header link if one is added.
  */
  renderLink() {
    if (!this.props.headerLink || !this.props.headerLink.text || !this.props.headerLink.url) {
      return false
    }

    const ref = this.props.metaData.name ? `header-link-${this.props.metaData.name}` : 'header-link'


    const linkHref = urlHelpers.addRef(this.props.headerLink.url, ref)


    const linkText = this.props.headerLink.text


    const linkLabel = this.props.headerLink.label ? this.props.headerLink.label : `${this.props.headerLink.text} ${this.props.headerTitle}`

    return (
      <a
        href={linkHref}
        title={linkLabel}
        aria-label={linkLabel}
        className="can-override-text"
      >
        { linkText }
      </a>
    )
  }

  render() {
    // Don't render a header if there's no title present.
    if (!this.props.headerTitle) {
      return false
    }

    return (
      <header className={`is-header is-${this.props.headerType}`}>
        { this.renderHeading() }
        { this.renderLink() }
      </header>
    )
  }
}

Header.defaultProps = {
  headerType: 'default',
  headerLink: {},
  metaData: {},
}

Header.propTypes = {
  headerTitle: PropTypes.string,
  headerType: PropTypes.string,
  headerLink: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
    label: PropTypes.string,
  }),
  metaData: PropTypes.object,
}

export default Header
